export default "/images/vendor/flag-icons/flags/1x1/hn.svg?084f590fe38a14fc375519bd42532933";